//API
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';
export const TOGGLE_APP_DRAWER = 'toggle_app_drawer';
export const UPDATING_CONTENT = 'updating_content';

//APP SETTING
export const TOGGLE_NAV_COLLAPSED = 'toggle_nav_collapsed';
export const SET_INITIAL_PATH = 'set_initial_path';

// MENU
export const GET_MENU_APP = 'get_menu_app';

// MASTER DATA
export const GET_LIST_PENDIDIKAN = 'get_list_pendidikan';
export const GET_LIST_PRODI = 'get_list_prodi';
export const GET_LIST_PENDIDIKAN_ID = 'get_list_pendidikan_id';
export const GET_LIST_PRODI_BY_PENDIDIKAN = 'get_list_prodi_by_pendidikan';
export const GET_LIST_GOLONGAN = 'get_list_golongan';
export const GET_LIST_ESELON = 'get_list_eselon';
export const GET_LIST_TIPE_JABATAN = 'get_list_tipe_jabatan';
export const GET_LIST_JABFUNG = 'get_list_jabfung';
export const RESET_LIST_JABFUNG = 'reset_list_jabfung';
export const GET_LIST_JABFUNG_GENERAL = 'get_list_jabfung_general';
export const GET_LIST_CLUSTER = 'get_list_cluster';
export const GET_LIST_SUBCLUSTER = 'get_list_subcluster';
export const GET_LIST_GAJI = 'get_list_gaji';
export const GET_LIST_GOLONGAN_CHOICE = 'get_list_golongan_choice';
export const GET_LIST_NEGARA_MASTERDATA = 'get_list_negara_masterdata';
export const GET_LIST_UNKER_MASTERDATA = 'get_list_unker_masterdata';
export const GET_LIST_JAM_KERJA_MASTERDATA = 'get_list_jam_kerja_masterdata';
export const GET_LIST_TIM_KERJA_MASTERDATA = 'get_list_tim_kerja_masterdata';
export const GET_LIST_DIKLAT_JABATAN = 'get_list_diklat_jabatan';
export const GET_LIST_PROVINSI = 'get_list_provinsi';
export const GET_LIST_KOTA = 'get_list-kota';
export const GET_LIST_KECAMATAN = 'get_list_kecamatan';
export const GET_LIST_KELURAHAN = 'get_list_kelurahan';
export const GET_LIST_BAHASA_MASTERDATA = 'get_list_bahasa_masterdata';
export const GET_LIST_JENIS_CUTI_MASTERDATA = 'get_list_jenis_cuti_masterdata';
export const GET_LIST_JURUSAN_MASTERDATA = 'get_list_jurusan_masterdata';
export const GET_LIST_HARI_LIBUR_MASTERDATA = 'get_list_hari_libur_masterdata';
export const GET_LIST_UNIVERSITAS_MASTERDATA = 'get_list_universitas_masterdata';
export const GET_LIST_TINGKAT_PENDIDIKAN_MASTERDATA = 'get_list_tingkat_pendidikan_masterdata';
export const GET_LIST_SMP = "get-list-pendidikan_SMP_masterdata"
export const GET_LIST_SD = "get-list-pendidikan_SD_masterdata"
export const GET_LIST_SEKOLAH = 'get_list_sekolah';
export const GET_LIST_JABATAN_MASTERDATA = 'get_list_jabatan_masterdata';
export const GET_LIST_KEDUDUKAN_MASTERDATA = 'get_list_kedudukan_masterdata';
export const GET_LIST_PP_PELANGGARAN_MASTERDATA = 'get_list_pp_pelanggaran_masterdata';
export const GET_LIST_TINGKAT_PENDIDIKAN = 'get_list_tingkat_pendidikan';
export const GET_OPTION_SHIFT = 'get_option_shift';
export const GET_OPTION_JURUSAN = 'get_option_jurusan';
export const GET_OPTION_SEKOLAH = 'get_option_sekolah';
export const RESET_OPTION_JURUSAN = 'reset_option_jurusan';
export const GET_OPTION_JENIS_DIKLAT = 'get_option_jenis_diklat';
export const GET_OPTION_KATEGORI_DIKLAT = 'get_option_kategori_diklat';
export const GET_ESELON_OPTION = 'get_eselon_option';
export const GET_PEGAWAI_PENSIUN_OPTION = 'get_pegawai_pensiun_option';
export const GET_OPTION_BIDANG_KEAHLIAN = 'get_option_bidang_keahlian';

// DATA KELUARGA
export const GET_DATA_PASANGAN = 'get_data_pasangan';
export const GET_DATA_ANAK = 'get_data_anak';
export const GET_DATA_KELUARGA = 'get_data_keluarga';

// DATA PENGHARGAAN
export const GET_DATA_PENGHARGAAN = 'get_data_penghargaan';

// DATA PEGAWAI BIDANG KEAHLIAN
export const GET_LIST_BIDANG_KEAHLIAN_PEGAWAI = 'get_list_bidang_keahlian_pegawai';
export const UPLOAD_ATTACHMENT_PEGAWAI_KEAHLIAN = 'upload_attachment_pegawai_keahlian';
export const UPDATE_ATTACHMENT_PEGAWAI_KEAHLIAN = 'update_attachment_pegawai_keahlian';

// DATA PEGAWAI ASN ADMIN & OPERATOR
export const GET_PEGAWAI_ASN = 'get_pegawai_asn';
export const GET_PEGAWAI_JPT = 'get_pegawai_jpt';
export const GET_PEGAWAI_PJLP = 'get_pegawai_pjlp';
export const GET_PEGAWAI_KONTRAK = 'get_pegawai_kontrak';
export const GET_CREATE_KELUARGA = 'get_create_keluarga';
export const GET_CREATE_ANAK = 'get_create_anak';
export const GET_LIST_BAHASA = 'get_create_bahasa';
export const GET_CREATE_PASANGAN = 'get_create_pasangan';
export const GET_CREATE_BERKAS_ELEKTRONIK = 'get_create_berkas_elektronik';
export const GET_DETAIL_PEGAWAI_ASN = 'get_detail_pegawai_asn';
export const GET_DETAIL_PEGAWAI_KONTRAK = 'get_detail_pegawai_kontrak';
export const GET_DETAIL_PEGAWAI_ASN_POKOK = 'get_detail_pegawai_asn_pokok';
export const GET_LIST_KGB = 'get_list_kgb';
export const GET_LIST_HUKDIS = 'get_list_hukdis';
export const GET_LIST_DIKLAT_PERJENJANGAN = 'get_list_diklat_perjenjangan';
export const GET_DATA_TUGAS_IZIN_BELAJAR = 'get_data_tugas_izin_belajar';
export const GET_PEGAWAI_AKAN_PENSIUN = 'get_pegawai_akan_pensiun';
export const GET_LIST_PENYESUAIAN_IJAZAH = 'get_list_penyesuaian_ijazah';
export const GET_LIST_PEGAWAI_DRH = 'get_list_pegawai_drh';
export const GET_LIST_PENDIDIKAN_FORMAL = 'get_list_pendidikan_formal';
export const GET_LIST_KEPANGKATAN = 'get_list_kepangkatan';
export const GET_LIST_PENDIDIKAN_INFORMAL = 'get_list_pendidikan_informal';
export const GET_LIST_CLTN = 'get_list_cltn';
export const GET_DIKLAT_PEGAWAI = 'get_diklat_pegawai';
export const GET_LIST_JABATAN = 'get_list_jabatan';

// DATA PJLP ADMIN & OPERATOR
export const GET_DETAIL_PEGAWAI_PJLP = 'get_detail_pegawai_pjlp';

// DATA PEGAWAI MASTER DATA
export const GET_DETAIL_PEGAWAI = 'get_detail_pegawai';
export const GET_KATEGORI_ASN = 'get_kategori_asn';
export const GET_DETAIL_KATEGORI_ASN = 'get_detail_kategori_asn';
export const GET_STATUS_PEGAWAI = 'get_status_pegawai';
export const GET_DETAIL_STATUS_PEGAWAI = 'get_detail_status_pegawai';
export const GET_PENGHARGAAN_SLKS = 'get_penghargaan_slks';
export const GET_DETAIL_PENGHARGAAN_SLKS = 'get_penghargaan_slks';
export const GET_GENDER = 'get_gender';
export const GET_DETAIL_GENDER = 'get_detail_gender';
export const GET_PERKAWINAN = 'get_perkawinan';
export const GET_DETAIL_PERKAWINAN = 'get_detail_perkawinan';
export const GET_AGAMA = 'get_agama';
export const GET_DETAIL_AGAMA = 'get_detail_agama';
export const GET_GOLDAR = 'get_goldar';
export const GET_DETAIL_GOLDAR = 'get_detail_goldar';
export const GET_JABATAN = 'get_jabatan';
export const GET_UNKER = 'get_all_unker';
export const GET_ALL_UNKER = 'get_unker';
export const GET_UNKER_GENERAL = 'get_unker_general';
export const GET_UNKER_CHOICE = 'get_unker_choice';
export const RESET_UNKER_LEVEL_CHOICE = 'reset_unker_level_choice';
export const GET_JABATAN_BY_UNKER = 'get_jabatan_by_unker';
export const GET_PELANGGARAN_PP = 'get_pelanggaran_pp';
export const GET_KODE_HUKUMAN = 'get_kode_hukuman';
export const GET_KODE_PEJABAT_BERWENANG = 'get_kode_penjabat_berwenang';
export const GET_PENYAMPAIAN_KEPUTUSAN_HUKUMAN = 'get_penyampaian_keputusan_hukuman';
export const GET_UPAYA_ADMINISTRATIF = 'get_upaya_administratif';
export const GET_STATUS_HUKDIS = 'get_status_hukdis';
export const GET_TIM_KERJA = 'get_tim_kerja';
export const GET_FORMASI_CPNS = 'get_formasi_cpns';
export const GET_STATUS_FORMASI_CPNS = 'get_status_formasi_cpns';
export const GET_CPNS_FUNGSIONAL_TIPE = 'get_cpns_fungsional_tipe';
export const GET_CPNS_FUNGSIONAL_KODE = 'get_cpns_fungsional_kode';
export const GET_SEARCH_PEGAWAI = 'get_search_pegawai';
export const RESET_SEARCH_PEGAWAI = 'reset_search_pegawai';
export const GET_LOKASI = 'get_lokasi';
export const GET_KATEGORI_PP_PELANGGARAN = 'get_kategori_pp_pelanggaran';
export const GET_LIST_NEGARA = 'get_list_negara';
export const GET_PROVINSI_BY_NEGARA = 'get_provinsi_by_negara';
export const GET_KOTA_BY_PROVINSI = 'get_kota_by_provinsi';
export const GET_KECAMATAN_BY_KOTA = 'get_kecamatan_by_kota';
export const GET_KELURAHAN_BY_KECAMATAN = 'get_kelurahan_by_kecamatan';
export const GET_OPTION_PROGRAM_KERJA = 'get_option_program_kerja';
export const GET_OPTION_STATUS_PROGRAM_KERJA = 'get_option_status_program_kerja';
export const GET_OPTION_INTERVENSI_PROGRAM_KERJA = 'get_option_intervensi_program_kerja';
export const RESET_JABATAN_OPTION = 'reset_jabatan_option';
export const GET_OPTION_STATUS_PEGAWAI = 'get_option_status_pegawai';
// MASTERDATA_V2
export const GET_KATEGORI_ASN_V2 = 'get_kategori_asn_v2';
export const GET_KATEGORI_ASN_TIPE_V2 = 'get_kategori_asn__tipe_v2';
export const RESET_KATEGORI_ASN_TIPE_V2 = 'reset_kategori_asn_tipe_v2';

// DASHBOARD
export const GET_DASHBOARD = 'get_dashboard';
export const GET_TABLE_DASHBOARD = 'get_table_dashboard';
export const GET_DASHBOARD_ULTAH = 'get_dashboard_ultah';
export const GET_DASHBOARD_ULTAH_TODAY = 'get_dashboard_ultah_today';
export const RESET_DASHBOARD_ULTAH = 'reset_dashboard_ultah';
export const GET_DASHBOARD_WAFAT = 'get_dashboard_wafat';
export const RESET_DASHBOARD_WAFAT = 'reset_dashboard_wafat';
export const RESET_DASHBOARD = 'reset_dashboard';
export const SEARCH_PEGAWAI_BY_PENDIDIKAN = 'search_pegawai_by_pendidikan';
export const GET_KOMPARASI_PEGAWAI = 'get_komparasi_pegawai';
export const RESET_KOMPARASI_PEGAWAI = 'reset_komparasi_pegawai';
export const GET_PEGAWAI_BY = 'get_pegawai_by';
export const GET_DASHBOARD_USIA = 'get_dashboard_usia';
export const GET_DETAIL_DASHBOARD_USIA = 'get_detail_dashboard_usia';
export const RESET_DETAIL_DASHBOARD_USIA = 'reset_detail_dashboard_usia';
export const GET_DETAIL_DASHBOARD_PANGKAT = 'get_detail_dashboard_pangkat';
export const GET_DETAIL_DASHBOARD_PENSIUN = 'get_detail_dashboard_pensiun';
export const GET_SLKS_DASHBOARD = 'get_slks_dashboard';
export const GET_DETAIL_UPT_DASHBOARD = 'get_detail_dashboard_upt';
export const GET_MARKER_MAPS_UPT = 'get_marker_maps_upt';
export const RESET_PEGAWAI_BY = 'reset_pegawai_by';
export const GET_DASHBOARD_PROGRAM_KERJA = 'get_dashboard_program_kerja';
// DASHBOARD_V2
export const GET_DASHBOARD_V2 = 'get_dashboard_v2';
export const RESET_DASHBOARD_V2 = 'reset_dashboard_v2';
export const GET_DASHBOARD_ESELON_1 = 'get_dashboard_eselon_1';
export const GET_DETAIL_DASHBOARD_ESELON_1 = 'get_detail_dashboard_eselon_1';

// LAPORAN
export const GET_NOMINATIF = 'get_nominatif';
export const GET_LAPORAN_KEPANGKATAN = 'get_laporan_kepangkatan';
export const GET_NAIK_GAJI_BERKALA = 'get_naik_gaji_berkala';
export const GET_DIKLAT_PERJENJANGAN = 'get_diklat_perjenjangan';
export const GET_SUMPAH_PEGAWAI = 'get_sumpah_pegawai';
export const GET_PRAJABATAN = 'get_prajabatan';
export const GET_SLKS = 'get_slks';
export const GET_PENDIDIKAN_JURUSAN = 'get_pendidikan_jurusan';
export const GET_REKAPITULASI_PEGAWAI = 'get_rekapitulasi_pegawai';
export const RESET_REKAPITULASI_PEGAWAI = 'reset_rekapitulasi_pegawai';
export const GET_LIST_TIPE_REKAP = 'get_list_tipe_rekap';
export const GET_LAPORAN_JUMLAH_JABATAN_UNIT = 'get_laporan_jumlah_jabatan_unit';
export const GET_LIST_PEGAWAI_LAPORAN_JUMLAH_JABATAN_UNIT = 'get_list_pegawai_laporan_jumlah_jabatan_unit';
export const GET_LIST_LAPORAN_REKAPITULASI_PENGHARGAAN_ASN = 'get_list_laporan_rekapitulasi_penghargaan_asn';
export const GET_OPTION_PENGHARGAAN_ASN = 'get_option_penghargaan_asn';

// LAPORAN JABFUNG
export const GET_PEJABAT_FUNGSIONAL = 'get_pejabat_fungsional';
export const GET_JENJANG_PEJABAT_FUNGSIONAL = 'get_jenjang_pejabat_fungsinal';
export const GET_JENJANG_PEJABAT_FUNGSIONAL_DAFTAR = 'get_jenjang_pejabat_fungsional_daftar';
export const RESET_JENJANG_PEJABAT_FUNGSIONAL = 'reset_jenjang_pejabat_fungsinal';
export const GET_PEGAWAI_FUNGSIONAL = 'get_pegawai_fugsional;'

//LAPORAN GRAFIK
export const GET_LAPORAN_GRAFIK_USIA = 'get_laporan_grafik_usia';
export const GET_LAPORAN_GRAFIK_TINGKAT_PENDIDIKAN = 'get_laporan_grafik_tingkat_pendidikan';
export const GET_LAPORAN_GRAFIK_GOLONGAN = 'get_laporan_grafik_golongan';
export const GET_LAPORAN_GRAFIK_STATUS_PEGAWAI = 'get_laporan_grafik_status_pegawai';
export const RESET_LAPORAN_GRAFIK = 'reset_laporan_grafik';
export const GET_DETAIL_LAPORAN_GRAFIK_USIA = 'get_detail_laporan_grafik_usia';
export const GET_DETAIL_LAPORAN_GRAFIK_TINGKAT_PENDIDIKAN = 'get_detail_laporan_grafik_tingkat_pendidikan';
export const GET_DETAIL_LAPORAN_GRAFIK_GOLONGAN = 'get_detail_laporan_grafik_golongan';
export const GET_DETAIL_LAPORAN_GRAFIK_STATUS_PEGAWAI = 'get_detail_laporan_grafik_status_pegawai';
export const RESET_DETAIL_GRAFIK_USIA = 'reset_detail_grafik_usia';

//LAPORAN KHUSUS
export const GET_INFORMASI_JABATAN = 'get_informasi_jabatan';

// DRH
export const GET_DRH = 'get_drh;'
export const GET_DETAIL_DATA_DIRI = 'get_detail_data_diri';
export const UPDATE_DETAIL_DATA_DIRI = 'update_detail_data_diri';
export const GET_DIKLAT_KURSUS_PEGAWAI = 'get_diklat_kursus_pegawai';

//KELOMPOK TALENTA
export const GET_KELOMPOK_TALENTA = 'get_kelompok_talenta'
export const SYNC_DATA_ASSESSMENT = 'sync_data_assessment'
export const GET_STATUS_SYNC_DATA_ASSESSMENT = 'get_status_sync_data_assessment'

//PREDIKAT E-KINERJA
export const GET_PREDIKAT_EKINERJA = 'get_predikat_ekinerja'

// UPLOAD BERKAS 
export const API_DATA_BERKAS_ELEKTRONIK = 'get_data_berkas';

//ADMINISTRASI KEPEGAWAIAN
export const GET_DATA_UJIAN_DINAS = 'get_data_ujian_dinas';
export const GET_DATA_LOKASI_NEGARA = 'get_data_lokasi_negara';

// MANAJEMEN TIM KERJA
export const GET_LIST_TIM_KERJA_OPERATOR = 'get_list_tim_kerja_operator';
export const GET_LIST_TIM_KERJA_ADMINISTRATOR = 'get_list_tim_kerja_administrator';
export const GET_DETAIl_TIM_KERJA = 'get_detail_tim_kera';
export const GET_LIST_ANGGOTA_TIM_KERJA = 'get_list_anggota_tim_kerja';
export const GET_OPTION_TIM_KERJA_CATEGORY = 'get_option_tim_kerja_category';
export const GET_PIMPINAN_TIM_KERJA = 'get_pimpinan_tim_kerja';

// LOGBOOK
export const GET_LIST_AKTIVITAS_GENERAL = 'get_list_aktivitas_general'

// PENGATURAN
export const GET_LIST_MENUS = 'get_list_menus';
export const GET_LIST_PEGAWAI_ROLE = 'get_list_pegawai_role';
export const GET_LIST_MENU_HAK_AKSES = 'get_list_menu_hak_akses';

// MONITORING 
export const GET_LIST_MONITORING_OPERATOR = 'get_list_monitoring_operator';
export const GET_LIST_MONITORING_STATUS_SIASN = 'get_list_monitoring_status_siasn';
export const GET_LIST_PROGRESS_MONITORING_ALL = 'get_list_progress_monitoring_all';

// SLKS
export const GET_LIST_PEGAWAI_SLKS = 'get_list_pegawai_slks';

// PROGRAM KERJA
export const GET_LIST_PROGRAM_KERJA = 'get_list_program_kerja';
export const ADD_ATTACHMENT_PROGRAM_KERJA = 'add_attachment_program_kerja';
export const SET_ATTACHMENT_PROGRAM_KERJA = 'set_attachment_program_kerja';
export const DELETE_ATTACHMENT_PROGRAM_KERJA = 'delete_attachment_program_kerja';

// UPDATE MANUAL DATA DRH CHECK PROGRESS
export const UPDATE_MANUAL_DATA_DRH_PEGAWAI = 'update_manual_data_drh_pegawai';
export const UPDATE_MANUAL_DOKUMEN_DRH_PEGAWAI = 'update_dokumen_data_drh_pegawai';
export const SET_PROGRESS_UPDATE_DRH = 'set_progress_update_drh';
export const CLEAR_PROGRESS_UPDATE_DRH = 'clear_progress_update_drh';

// PRESENSI
export const GET_PERSONAL_DASHBOARD_PRESENSI = 'get_personal_dashboard_presensi';
export const GET_PERSONAL_LIST_LOG_PRESENSI = 'get_personal_list_log_presensi';
export const GET_PRESENSI_SOURCE_OPTION = 'get_presensi_source_option';

// UMPAN BALIK 360
export const GET_LIST_PENILAIAN = 'get_list_penilaian';
export const GET_LIST_QUESTIONS = 'get_list_questions';
export const GET_DASHBOARD_ADMIN = 'get_dashboard_admin';
export const GET_DASHBOARD_ME = 'get_dashboard_me';
export const GET_LIST_REPORT_PROSES = 'get_list_report_proses';
export const GET_LIST_REPORT_PROSES_PIMPINAN = 'get_list_report_proses_pimpinan';
export const GET_LIST_REPORT_REKAP = 'get_list_report_rekap';
export const GET_DETAIL_PENILAIAN = 'get_detail_penilaian';
export const GET_LIST_HISTORI_GENERATE = 'get_list_histori_generate';
export const GET_OPTION_INDIKATOR_ASSESSMENT = 'get_option_indikator_assessment';
export const GET_LIST_PROGRES_EXPORT = 'get_list_progres_export';
export const GET_LIST_ROLE_AKSES = 'get_list_role_akses';
export const GET_LIST_RELATIONS = 'get_list_relations';
export const GET_DETAIL_RELATION = 'get_detail_relation';
export const RESET_DETAIL_RELATION = 'reset_detail_relation';
export const GET_DETAIL_REPORT_PROSES = 'get_detail_report_proses';
export const GET_LIST_PEGAWAI_BY_STATUS_PENILAIAN = 'get_list_pegawai_by_status_penilaian';
export const RESET_LIST_PEGAWAI_BY_STATUS_PENILAIAN = 'reset_list_pegawai_by_status_penilaian';
// MASTER UMPAN BALIK 360
export const GET_LIST_QUESTIONS_MASTER = 'get_list_questions_master';
export const GET_OPTION_ROLE = 'get_option_role';
export const GET_OPTION_PEGAWAI_360 = 'get_option_pegawai';
export const GET_OPTION_ROLE_PENILAI = 'get_option_role_penilai';
export const GET_LIST_QUARTER = 'get_list_quarter';
export const GET_DETAIL_QUARTER = 'get_list_quarter';
export const GET_OPTION_ASSESSMENT = 'get_option_assessment';